import { render } from "./semesterHighlights.vue?vue&type=template&id=febba33e&scoped=true"
import script from "./semesterHighlights.vue?vue&type=script&lang=js"
export * from "./semesterHighlights.vue?vue&type=script&lang=js"

import "./semesterHighlights.vue?vue&type=style&index=0&id=febba33e&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-febba33e"]])

export default __exports__